import { Component } from "@angular/core";
import { SharedDataService } from "../../services/shared-data.service";
import { DatePipe } from "@angular/common";
import { NormalizeDataService } from "../../services/normalize-data.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { environment } from "../../../environments/environment";

const { baseUrl } = environment;
@Component({
    selector: "app-conciliations-update",
    standalone: true,
    imports: [RouterModule],
    templateUrl: "./conciliations-update.component.html",
    styleUrl: "./conciliations-update.component.css"
})
export class ConciliationsUpdateV2Component {
  formattedCreatedAtFrom: string = "";
  formattedcreatedAtTo: string = "";

  constructor(private http: HttpClient, public sharedDataService: SharedDataService, private datePipe: DatePipe, public normalizeDataService: NormalizeDataService) {
    this.formattedCreatedAtFrom = this.datePipe.transform(localStorage.getItem("calendar.created_at_from"), "dd-MM-yyyy");
    this.formattedcreatedAtTo = this.datePipe.transform(localStorage.getItem("calendar.created_at_to"), "dd-MM-yyyy");
  }

  ngOnInit(): void {
    // Captura valores desde el hash URL (e.g., #pi.idTransaccion=.../#pi.fechaTransaccion=...)
    const fullHash = window.location.hash;
    const parts = fullHash.split("/");
    const params: Record<string, string> = {};

    parts.forEach((part) => {
      const clean = part.replace("#", "");
      const [key, val] = clean.split("=");
      if (key && val) {
        params[key] = decodeURIComponent(val);
      }
    });

    const idTransaccion = params["pi.rrn"];
    const fechaTransaccion = params["pi.fecha"];
    const estado = params["pi.estado"];

    console.log("🧩 ID Transacción:", idTransaccion);

    if (idTransaccion) {
      this.enviarReinyeccion(idTransaccion, fechaTransaccion, estado);
    } else {
      console.warn("⚠️ No se encontró p.idArchivo en el hash URL");
    }
  }

  async enviarReinyeccion(idTransaccion: string, fechaISO: string, estado: string): Promise<void> {
    try {
      const token = localStorage.getItem("auth.access_token");
      if (!token) {
        console.error("❌ No se encontró el token de autenticación.");
        return;
      }

      // ✅ Convertimos la fecha a formato "dd-MM-yyyy"
      const fechaFormateada = this.datePipe.transform(fechaISO, "dd-MM-yyyy");

      const body = {
        id_transaccion: idTransaccion,
        accion: estado,
        fecha: fechaFormateada,
      };

      const headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      });

      const response = await this.http.post(`${baseUrl}/reinyeccion/conciliacion`, body, { headers }).toPromise();

      console.log("✅ Reinyección enviada correctamente:", response);
    } catch (error) {
      console.error("❌ Error al enviar reinyección:", error);
    }
  }
}
